import { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import api, { inr, fmtDate } from "../../lib/api";

export default function Billing() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/billing").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  const s = data?.summary;

  return (
    <div data-testid="billing-page">
      <h1 className="font-display text-2xl font-bold tracking-tight text-shipany-navy">Billing</h1>
      <p className="text-sm text-slate-500">Shipping charges, GST and invoices.</p>

      <div className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {[
          ["Total Spend", s?.total_spend, "text-shipany-blue"],
          ["GST Paid", s?.gst_paid, "text-slate-700"],
          ["COD Receivable", s?.cod_to_be_remitted, "text-amber-600"],
          ["Invoices", s?.invoice_count, "text-slate-700"],
        ].map(([label, val, cls]) => (
          <div key={label} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`billing-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">{label}</p>
            <p className={`mono mt-2 text-2xl font-bold ${cls}`}>{typeof val === "number" && label !== "Invoices" ? inr(val) : val ?? "—"}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 overflow-x-auto rounded-2xl border border-slate-200 bg-white" data-testid="invoices-table">
        <table className="w-full min-w-[640px] text-sm">
          <thead>
            <tr className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
              <th className="px-5 py-3">Invoice</th><th className="px-4 py-3">AWB</th><th className="px-4 py-3">Amount</th><th className="px-4 py-3">GST</th><th className="px-4 py-3">Status</th><th className="px-4 py-3">Date</th>
            </tr>
          </thead>
          <tbody>
            {(data?.invoices || []).map((inv) => (
              <tr key={inv.invoice_id} className="border-t border-slate-100">
                <td className="mono px-5 py-3.5 font-semibold text-shipany-blue">
                  <a href={`${process.env.REACT_APP_BACKEND_URL}/api/shipments/${inv.shipment_id}/document?type=invoice`} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 hover:underline">
                    <Receipt className="h-3.5 w-3.5" />{inv.invoice_number}
                  </a>
                </td>
                <td className="mono px-4 py-3.5 text-slate-500">{inv.awb}</td>
                <td className="mono px-4 py-3.5 font-semibold">{inr(inv.amount)}</td>
                <td className="mono px-4 py-3.5 text-slate-500">{inr(inv.gst)}</td>
                <td className="px-4 py-3.5"><span className="rounded-full bg-emerald-50 px-2.5 py-0.5 text-[11px] font-bold uppercase text-emerald-600">{inv.status}</span></td>
                <td className="px-4 py-3.5 text-slate-500">{fmtDate(inv.created_at)}</td>
              </tr>
            ))}
            {data && data.invoices.length === 0 && <tr><td colSpan={6} className="px-6 py-10 text-center text-slate-400">No invoices yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
